<template>
  <view class="integral">
    <view class="head">
      <span class="title">当前剩余积分</span>
      <span class="score">
        <b class="number">688</b>
        分
      </span>
    </view>
    <ul>
      <li>
        <p class="title">
          <span>兑换商品</span>
          <b class="red">+1234</b>
        </p>
        <p class="time color-999">
          2020-06-28 18:28
        </p>
      </li>
      <li>
        <p class="title">
          <span>兑换商品</span>
          <b class="red">+1234</b>
        </p>
        <p class="time color-999">
          2020-06-28 18:28
        </p>
      </li>
    </ul>
  </view>
</template>

<script>
export default {
	data(){
		return{
			
		};
	}
};
</script>

<style lang="less" scoped>
.integral{
	padding:0 30upx;
	.head{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top:46upx;
		.title{
			color:#2A2E25;
			font-size: 500;
		}
		.score{
			color:#E3B979;
			.number{
				font-size: 44upx;
			}
		}
	}
	ul{
		overflow: hidden;
		margin-top:60upx;
		li{
			padding: 20upx 0;
			border-bottom:1px #D8D8D8 solid;
			.title{
				display: flex;
				justify-content: space-between;
			}
			.time{
				font-size: 22upx;
				margin-top:20upx;
			}
			.red{
				color:#F16346;
			}
		}
	}
}
</style>
